export default __webpack_public_path__ + "static/media/(16).501f7c6a.JPG";